(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/modals/_add_product.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"comet-modal-overlay js-comet-modal-overlay comet-modal-overlay--backdrop\" role=\"dialog\"></div>\n<div class=\"comet-modal js-comet-modal\" role=\"document\" tabindex=\"0\">\n    <div class=\"comet-modal__inner comet-modal--wide\">\n\n        ";
output += "\n        <div class=\"comet-modal__header comet-long-form-text\">\n            <h3 class=\"comet-modal__header-content\">Add Product</h3>\n        </div>\n\n        ";
output += "\n        <div class=\"comet-modal__content\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "errorMessage")) {
output += "\n                <div class=\"comet-block-message comet-block-message--error\" role=\"alert\">\n                    <div class=\"comet-block-message__icon-box\">\n                        <svg class=\"comet-block-message__icon\" aria-hidden=\"true\" focusable=\"false\">\n                            <use xlink:href=\"";
output += runtime.suppressValue((lineno = 15, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#message-error"])), env.opts.autoescape);
output += "\"></use>\n                        </svg>\n                    </div>\n                    <div class=\"comet-block-message__content comet-long-form-text\">\n                        <p>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "errorMessage"), env.opts.autoescape);
output += "</p>\n                    </div>\n                </div>\n            ";
;
}
output += "\n            <form class=\"admin-form admin-form--find-products\">\n                    <div class=\"comet-form__field-group comet-form--dense\">\n                        <label class=\"comet-form__label\" for=\"name\">\n                            Filter by Name\n                        </label>\n                        <input class=\"comet-form__input\" type=\"prefix\" id=\"prefix\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "searchParams")),"prefix"), env.opts.autoescape);
output += "\">\n                    </div>\n                    <div class=\"comet-form__field-group comet-form__field-group--horizontal comet-form--dense \">\n                        <div class=\"comet-form__field-group\">\n                            <div class=\"comet-form__select\">\n                                <select class=\"comet-form__select-input\" id=\"family_id\" name=\"family_id\">\n                                    ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form_choices")),"families");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                                        <option class=\"comet-form__select-option\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "</option>\n                                    ";
;
}
}
frame = frame.pop();
output += "\n                                </select>\n                                <div class=\"comet-form__select-visual-wrap\"></div>\n                                <span class=\"comet-form__select-open-indicator\">\n                                    <svg class=\"comet-form__select-open-icon\" aria-hidden=\"true\" focusable=\"false\">\n                                        <use xlink:href=\"";
output += runtime.suppressValue((lineno = 41, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#caret-down"])), env.opts.autoescape);
output += "\"></use>\n                                    </svg>\n                                </span>\n                            </div>\n                        </div>\n                        <div class=\"comet-form__field-group\">\n                            <div class=\"comet-form__select\">\n                                <select class=\"comet-form__select-input\" id=\"region_code\" name=\"region_code\">\n                                    ";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form_choices")),"regions");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                                        <option\n                                            class=\"comet-form__select-option\"\n                                            value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"region_id"), env.opts.autoescape);
output += "\"\n                                            data-country-code=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"country_code"), env.opts.autoescape);
output += "\"\n                                            ";
if(runtime.memberLookup((t_8),"selected")) {
output += " selected";
;
}
output += ">\n                                                ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"name"), env.opts.autoescape);
output += "\n                                        </option>\n                                    ";
;
}
}
frame = frame.pop();
output += "\n                                </select>\n                                <div class=\"comet-form__select-visual-wrap\"></div>\n                                <span class=\"comet-form__select-open-indicator\">\n                                    <svg class=\"comet-form__select-open-icon\" aria-hidden=\"true\" focusable=\"false\">\n                                        <use xlink:href=\"";
output += runtime.suppressValue((lineno = 62, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#caret-down"])), env.opts.autoescape);
output += "\"></use>\n                                    </svg>\n                                </span>\n                            </div>\n                        </div>\n                        <div class=\"comet-form__field-group\">\n                            <div class=\"comet-form__select\">\n                                <select class=\"comet-form__select-input\" id=\"status_id\" name=\"status_id\">\n                                    ";
frame = frame.push();
var t_11 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "form_choices")),"statuses");
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                                        <option class=\"comet-form__select-option\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "</option>\n                                    ";
;
}
}
frame = frame.pop();
output += "\n                                </select>\n                                <div class=\"comet-form__select-visual-wrap\"></div>\n                                <span class=\"comet-form__select-open-indicator\">\n                                    <svg class=\"comet-form__select-open-icon\" aria-hidden=\"true\" focusable=\"false\">\n                                        <use xlink:href=\"";
output += runtime.suppressValue((lineno = 77, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#caret-down"])), env.opts.autoescape);
output += "\"></use>\n                                    </svg>\n                                </span>\n                            </div>\n                        </div>\n\n                    </div>\n\n                    <div class=\"add-products__search-results-table\"></div>\n            </form>\n        </div>\n\n        ";
output += "\n        <div class=\"comet-modal__footer\">\n            <div class=\"comet-modal__button-row\">\n                <button type=\"button\" class=\"comet-button comet-button--ghost comet-modal__button comet-modal__button--cancel js-comet-modal__close-button\">Cancel</button>\n                <button type=\"button\" id=\"add-products\" class=\"comet-button comet-button--primary comet-modal__button comet-modal__button--confirm\">Add</button>\n            </div>\n        </div>\n\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/modals/_add_product", function(){});

